import { Adjust, Receipt } from '@mui/icons-material';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const adjustment = {
    id: 'adjustment',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'adjustment',
            title: 'Adjustment',
            type: 'item',
            url: '/adjustment',
            icon: Adjust,
            breadcrumbs: false,
            
        }
    ]
};

export default adjustment;
